import PropTypes from 'prop-types';
import styles from './styles.module.scss';

EmailsSelect.propTypes = {
  children: PropTypes.any,
  isOpenSelects: PropTypes.bool,
  currentEmail: PropTypes.string,
  arrMails: PropTypes.arrayOf(PropTypes.string),
  setEmail: PropTypes.func,
};

export function EmailsSelect({
  children,
  isOpenSelects,
  currentEmail,
  arrMails,
  setEmail,
}) {
  const setEmailResource = (resource) => {
    const filteredEmail = currentEmail.split('@')[0];
    setEmail(filteredEmail + resource);
  };

  return (
    <>
      {children}

      {isOpenSelects && (
        <div
          className={`${styles[`login-wrapper__select`]} ${
            arrMails.length > 4
              ? `${styles[`login-wrapper__select--more`]}`
              : ''
          }`}
        >
          <ol className={styles[`login-wrapper__select-holder`]}>
            {arrMails.map((email, index) => (
              <li
                key={index}
                className={styles[`login-wrapper__select-holder_item`]}
                onClick={() => setEmailResource(`@${email}`)}
              >
                @{email}
              </li>
            ))}
          </ol>
        </div>
      )}
    </>
  );
}
